<template>
    <div class="content">
      <div class="container-fluid">
        <div class="row">
  <b-modal
    id="modal-top-add-bulk"
    hide-footer
    title="Add Customer"
    content-class="shadow"
  >
  <!-- Loading Indicator -->
  <div v-if="loading" class="text-center mb-3">
    <b-spinner label="Loading..."></b-spinner>
    <p>Please wait while we upload your data.</p>
  </div>
    <!-- Modal Header -->
    <template #modal-header="{ close }">
      <h5>{{ translate('addBulkData') }}</h5>
      <p class="h5 mb-2">
        <b-icon
          icon="x-square"
          class="close-icon"
          @click="
            close();
            clearData();
          "
        ></b-icon>
      </p>
    </template>

    <!-- Download Sample File Button -->
    <b-row class="mb-3">
      <b-col md="12" class="text-center">
        <b-button
          variant="success"
          @click="downloadSampleFile"
        >
          {{ translate('downloadSampleFile') }}
        </b-button>
      </b-col>
    </b-row>

    <!-- File Upload Section -->
    <b-row>
      <b-col md="12">
        <label>{{ translate('uploadExcelFile') }}</label>
        <b-form-file
          v-model="file"
          @change="onFileSelected"
          ref="fileInput"
          accept=".csv, .xls, .xlsx"
          class="mb-2"
        ></b-form-file>
      </b-col>
    </b-row>

    <!-- Submit Button -->
    <b-row>
      <b-col md="12">
        <b-button
          variant="primary"
          @click="confirmAndSubmitFile"
          :disabled="loading"
        >
        {{ translate('submit') }}
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</div>
        <div class="row mt-3">
          <div class="col-12">
            <card class="strpied-tabled-with-hover"
                  body-classes="table-full-width table-responsive"
            >
              <template slot="header">
                <b-row>
                <!-- <b-col lg="4" class="my-1">
                  <b-button v-if="modulePermission.create == 1" @click="AddEkub()" class="btn-outline-primary">
                    <b-icon class="text-center" icon="plus"></b-icon> {{ translate('newAssociation') }}
                  </b-button>
              </b-col>
              <b-col lg="4" class="my-1">
            <b-button v-if="modulePermission.create === 1" @click="triggerFileInput" class="btn-outline-primary">
              <b-icon class="text-center" icon="plus"></b-icon> {{ translate('addBulkData') }}
            </b-button>
          </b-col> -->
               <b-col lg="12" class="my-3">
                    <b-form-group class="mb-0">
                      <b-input-group size="sm">
                        <b-form-input
                          id="filter-input"
                          v-model="filter"
                          type="search"
                          placeholder="Filter"
                        ></b-form-input>
  
                        <b-input-group-append>
                          <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''"
                            >Clear</b-button
                          >
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </template>
              
              <template>
                <div class="table-container">
                <b-table-simple
                  :small="true"
                  sticky-header
                  style="max-height: 395px;"
                  striped
                  responsive
                  hover
                >
                  <b-thead class="sticky-header">
                    <b-tr>
                      <b-th>{{ translate('no') }}</b-th>
                      <b-th>{{ translate('associationId') }}</b-th>
                      <b-th>{{ translate('associationName') }}</b-th>
                      <b-th>{{ translate('associationType') }}</b-th>
                      <b-th>{{ translate('associationAmount') }}</b-th>
                      <b-th>{{ translate('numberOfMembers') }}</b-th>
                      <b-th>{{ translate('startDate') }}</b-th>
                      <b-th>{{ translate('endDate') }}</b-th>
                      <b-th>{{ translate('cycle') }}</b-th>
                      <b-th>{{ translate('createdAt') }}</b-th>
                      <b-th>{{ translate('createdBy') }}</b-th>
                      <b-th>{{ translate('description') }}</b-th>
                      <b-th sticky-column style="height: 45px;"></b-th>
                    </b-tr>
                  </b-thead>
                  <template v-if="spinner">
                  <b-tbody class="text-center">
                     <b-tr >
                         <b-td colspan="6" class="text-center" style="display: table-cell">
                          <b-spinner
                          style="height: 3rem; width: 3rem;"
                            variant="warning"
                          ></b-spinner>
                         </b-td>
                      </b-tr>
                  </b-tbody>
                  </template>
                  <template v-else>
                    <b-tbody>
                    <template v-if="filterTable.length === 0">
                        <b-tr>
                          <b-td colspan="5" class="text-center">{{ translate('nothingFound') }}</b-td>
                          <b-td></b-td>
                        </b-tr>
                    </template>
                    <template v-else>
                    <b-tr
                      v-for="(item, index) in filterTable"
                      :key="item.ID"
                    >
                        <b-td>{{(currentPage - 1) * perPage + index + 1}}</b-td>
                        <b-td>{{item.associationId}}</b-td>
                        <b-td>{{item.ekubName}}</b-td>
                        <b-td>{{item.ekubType}}</b-td>
                        <b-td>{{item.ekubAmount}}</b-td>
                        <b-td>{{item.numberOfEkuber}}</b-td>
                        <b-td>{{item.ekubStartDate}}</b-td>
                        <b-td>{{item.ekubEndDate}}</b-td>
                        <b-td>{{item.cycleString}}</b-td>
                        <b-td>{{item.createdDate}}</b-td>
                        <b-td>{{item.registeredBy}}</b-td>
                        <b-td>{{item.description}}</b-td>
                        <b-td sticky-column style="padding: 0px 0px !important;">
                          <b-row>
                            <!-- <b-col md="6" class="mb-2" v-if="modulePermission.update == 1">
                              <b-icon icon="pencil-square" class="btn-icon" :title= "translate('editAssociation')"  @click="EditEkub(item.ekubId)" aria-hidden="true" ></b-icon>
                            </b-col> -->
                          </b-row>
                        </b-td>
                    </b-tr>
                    </template>
                  </b-tbody>
                  </template>
                </b-table-simple>
              </div>
                 <!-- Pagination outside the table to prevent overlap -->
            <div class="pagination-container">
              <b-row class="mt-3 align-items-center justify-content-between">
                <b-col class="d-flex align-items-center">
                  <label class="mr-2 mb-0">{{ translate('recordsPerPage') }}</label>
                  <b-form-select
                    id="input-horizontal"
                    class="custom-dropdown"
                    v-model="perPage"
                    :options="pageOptions"
                    @change="changePerPage"
                  >
                  </b-form-select>
                </b-col>
                <b-col class="d-flex justify-content-end">
                  <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totalRows"
                    @page-click="changePage"
                    align="right"
                  />
                </b-col>
              </b-row>
            </div>
              </template>
            </card>
          </div>
        </div>
        <div class="row">
          <b-modal
              id="modal-center-add"
              hide-footer
              title="Add Ekub"
              content-class="shadow" 
            >
              <template #modal-header="{ close }">
                <h5>{{ translate('addAssociation') }}</h5>
                <p class="h5 mb-2">
                  <b-icon
                    icon="x-square"
                    class="close-icon"
                    @click="
                      close();
                      clearData();
                    "
                  ></b-icon>
                </p>
              </template>
              <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form
                  class="text-left"
                  @submit.stop.prevent="handleSubmit(submitAddForm)"
                >
                  <b-row no-gutters>
                    <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <Vinput
                        inputType="text"
                        :modelValue="addData.ekubName"
                        @update:modelValue="
                          (newValue) => (addData.ekubName = newValue)
                        "
                        :rules="{ required: true }"
                        id="text-ekubName"
                        name="text-ekubName"
                        :label="translate('associationName')" 
                        class="mb-1 mr-sm-2"
                        description="text-ekubName-feedback"
                        validatorName="Association Name"
                      />
                    </b-col>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addData.ekubType"
                      @update:modelValue="
                        (newValue) => (addData.ekubType = newValue)
                      "
                        :options="ekubTypeOptions"
                      :rules="{ required: true }"
                      id="text-ekub-type-options"
                      name="text-ekub-type-options"
                      :label="translate('associationType')" 
                      class="mb-1 mr-sm-2 some-select"
                      description="text-ekub-type-options-feedback"
                      validatorName="Association Type"
                    />
                  </b-col>
                    <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <VinputNumber
                      inputType="number"
                        :modelValue="addData.ekubAmount"
                        @update:modelValue="
                          (newValue) => (addData.ekubAmount = newValue)
                        "
                        :rules="{ required: true }"
                        id="text-ekubAmount"
                        name="text-ekubAmount"
                        :label="translate('associationAmount')" 
                        class="mb-1 mr-sm-2"
                        description="text-ekubAmount-feedback"
                        validatorName="Association Amount"
                      />
                    </b-col>
                    <b-row style="">
                        <b-col
                          xs="1"
                          style="justify-content: center; align-items: center"
                        >
                         <Vselect
                          :modelValue="addData.cycle"
                          @update:modelValue="
                            (newValue) => (addData.cycle = newValue)
                          "
                            :options="cycleOptions"
                          :rules="{ required: true }"
                          id="text-cycle"
                          name="text-cycle"
                          :label="translate('cycle')" 
                          class="mb-1 mr-sm-2 some-select"
                          description="text-cycle-feedback"
                          validatorName="Cycle"
                        />
                        </b-col>
                         <b-col
                          xs="2"
                          style="justify-content: center; align-items: center"
                        >
                        <Vselect
                          :modelValue="addData.cycletwo"
                          @update:modelValue="
                            (newValue) => (addData.cycletwo = newValue)
                          "
                            :options="cycleOptions2"
                          :rules="{ required: true }"
                          id="text-cycletwo"
                          name="text-cycletwo"
                          label="*"
                          class="mb-1 mr-sm-2 some-select"
                          description="text-cycletwo-feedback"
                          validatorName="Cycle"
                        />
                        </b-col>
                        <!-- hellohello -->
                        <b-col
                          xs="9"
                          style="justify-content: right; align-items: right"
                        ></b-col>
                        </b-row>
                    <!-- <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <VinputNumber
                      inputType="number"
                        :modelValue="addData.numberOfEkuber"
                        @update:modelValue="
                          (newValue) => (addData.numberOfEkuber = newValue)
                        "
                        :rules="{ required: true }"
                        id="text-numberOfEkuber"
                        name="text-numberOfEkuber"
                        :label="translate('numberOfMembers')" 
                        class="mb-1 mr-sm-2"
                        description="text-numberOfEkuber-feedback"
                        validatorName="Number Of Ekuber"
                      />
                    </b-col> -->
                    <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                        >
                          <Vinput
                            inputType="date"
                            :modelValue="addData.startDate"
                            @update:modelValue="
                              (newValue) => (addData.startDate = newValue)
                            "
                            :rules="{ required: true }"
                            id="text-startDate"
                            name="text-startDate"
                            :label="translate('startDate')" 
                            class="mb-1 mr-sm-2"
                            description="text-startDate-feedback"
                            validatorName="Start Date"
                          />
                        </b-col>
                         <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                        >
                          <Vinput
                          
                            inputType="date"
                            :modelValue="addData.endDate"
                            @update:modelValue="
                              (newValue) => (addData.endDate = newValue)
                            "
                            :rules="{ required: true }"
                            id="text-endDate"
                            name="text-endDate"
                            :label="translate('endDate')" 
                            class="mb-1 mr-sm-2"
                            description="text-endDate-feedback"
                            validatorName="End Date"
                          />
                        </b-col>
                    <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <Vinput
                        inputType="text"
                        :modelValue="addData.description"
                        @update:modelValue="
                          (newValue) => (addData.description = newValue)
                        "
                        :rules="{}"
                        id="text-description"
                        name="text-description"
                        :label="translate('description')" 
                        class="mb-1 mr-sm-2"
                        description="text-description-feedback"
                        validatorName="Description"
                      />
                    </b-col>
                    <b-col class="mt-2">
                      <b-button type="submit" variant="primary">{{translate('submit')}} </b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </b-modal>
        </div>
        <div class="row">
          <b-modal
              id="modal-top-EditEkub"
              hide-footer
              title="Edit Ekub"
              content-class="shadow" 
            >
              <template #modal-header="{ close }">
                <h5>{{ translate('editAssociation') }}</h5>
                <p class="h5 mb-2">
                  <b-icon
                    icon="x-square"
                    class="close-icon"
                    @click="
                      close();
                      clearData();
                    "
                  ></b-icon>
                </p>
              </template>
              <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form
                  class="text-left"
                  @submit.stop.prevent="handleSubmit(submitEditForm)"
                >
                  <b-row no-gutters>
                     <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <Vinput
                        inputType="text"
                        :modelValue="selectedEkub.ekubName"
                        @update:modelValue="
                          (newValue) => (selectedEkub.ekubName = newValue)
                        "
                        :rules="{ required: true }"
                        id="text-ekubName"
                        name="text-ekubName"
                        :label="translate('associationName')" 
                        class="mb-1 mr-sm-2"
                        description="text-ekubName-feedback"
                        validatorName="Association Name"
                      />
                    </b-col>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="selectedEkub.ekubType"
                      @update:modelValue="
                        (newValue) => (selectedEkub.ekubType = newValue)
                      "
                        :options="ekubTypeOptions"
                      :rules="{ required: true }"
                      id="text-ekub-type-options"
                      name="text-ekub-type-options"
                      :label="translate('associationType')" 
                      class="mb-1 mr-sm-2 some-select"
                      description="text-ekub-type-options-feedback"
                      validatorName="Association Type"
                    />
                  </b-col>
                    <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <VinputNumber
                      inputType="number"
                        :modelValue="selectedEkub.ekubAmount"
                        @update:modelValue="
                          (newValue) => (selectedEkub.ekubAmount = newValue)
                        "
                        :rules="{ required: true }"
                        id="text-ekubAmount"
                        name="text-ekubAmount"
                        :label="translate('associationAmount')" 
                        class="mb-1 mr-sm-2"
                        description="text-ekubAmount-feedback"
                        validatorName="Association Amount"
                      />
                    </b-col>
                    <b-row style="">
                        <b-col
                          xs="1"
                          style="justify-content: center; align-items: center"
                        >
                         <Vselect
                          :modelValue="selectedEkub.cycle"
                          @update:modelValue="
                            (newValue) => (selectedEkub.cycle = newValue)
                          "
                            :options="cycleOptions"
                          :rules="{ required: true }"
                          id="text-cycle"
                          name="text-cycle"
                          :label="translate('cycle')" 
                          class="mb-1 mr-sm-2 some-select"
                          description="text-cycle-feedback"
                          validatorName="Cycle"
                        />
                        </b-col>
                         <b-col
                          xs="2"
                          style="justify-content: center; align-items: center"
                        >
                        <Vselect
                          :modelValue="selectedEkub.cycletwo"
                          @update:modelValue="
                            (newValue) => (selectedEkub.cycletwo = newValue)
                          "
                            :options="cycleOptions2"
                          :rules="{ required: true }"
                          id="text-cycletwo"
                          name="text-cycletwo"
                          label="*"
                          class="mb-1 mr-sm-2 some-select"
                          description="text-cycletwo-feedback"
                          validatorName="Cycle"
                        />
                        </b-col>
                        <!-- hellohello -->
                        <b-col
                          xs="9"
                          style="justify-content: right; align-items: right"
                        ></b-col>
                        </b-row>
                  
                    <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                        >
                          <Vinput
                            inputType="date"
                            :modelValue="selectedEkub.startDate"
                            @update:modelValue="
                              (newValue) => (selectedEkub.startDate = newValue)
                            "
                            :rules="{ required: true }"
                            id="text-startDate"
                            name="text-startDate"
                            :label="translate('startDate')" 
                            class="mb-1 mr-sm-2"
                            description="text-startDate-feedback"
                            validatorName="Start Date"
                          />
                        </b-col>
                         <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                        >
                          <Vinput
                          
                            inputType="date"
                            :modelValue="selectedEkub.endDate"
                            @update:modelValue="
                              (newValue) => (selectedEkub.endDate = newValue)
                            "
                            :rules="{ required: true }"
                            id="text-endDate"
                            name="text-endDate"
                            :label="translate('endDate')" 
                            class="mb-1 mr-sm-2"
                            description="text-endDate-feedback"
                            validatorName="End Date"
                          />
                        </b-col>
                       <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <Vinput
                        inputType="text"
                        :modelValue="selectedEkub.description"
                        @update:modelValue="
                          (newValue) => (selectedEkub.description = newValue)
                        "
                        :rules="{}"
                        id="text-description"
                        name="text-description"
                        :label="translate('description')" 
                        class="mb-1 mr-sm-2"
                        description="text-description-feedback"
                        validatorName="Description"
                      />
                    </b-col>
                    <b-col class="mt-2">
                      <b-button type="submit" variant="primary">{{ translate('submit') }}</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </b-modal>
        </div>
         <div class="row">
          <b-modal
              id="modal-top-AddBillsForBuilding"
              hide-footer
              title="Add Bills"
              content-class="shadow" 
            >
              <template #modal-header="{ close }">
                <h5>Add Bills</h5>
                <p class="h5 mb-2">
                  <b-icon
                    icon="x-square"
                    class="close-icon"
                    @click="
                      close();
                      clearData();
                    "
                  ></b-icon>
                </p>
              </template>
              <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form
                  class="text-left"
                  @submit.stop.prevent="handleSubmit(submitChangeBillForm)"
                >
                  <b-row no-gutters>
                      <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                    <VinputNumber
                        inputType="number"
                        :modelValue="addBillData.electricPrice"
                        @update:modelValue="
                          (newValue) => (addBillData.electricPrice = newValue)
                        "
                        :rules="{ min_value: 0 }"
                        id="text-electric-price"
                        name="text-electric-price"
                        label="Electric Bill"
                        class="mb-1 mr-sm-2"
                        description="text-electric-price-feedback"
                        validatorName="Electric Bill"
                        :step=".01"
                      />
                     </b-col>
                       <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                     <VinputNumber
                        inputType="number"
                        :modelValue="addBillData.waterPrice"
                        @update:modelValue="
                          (newValue) => (addBillData.waterPrice = newValue)
                        "
                        :rules="{ min_value: 0 }"
                        id="text-water-price"
                        name="text-water-price"
                        label="Water Bill"
                        class="mb-1 mr-sm-2"
                        description="text-water-price-feedback"
                        validatorName="Water Bill"
                        :step=".01"
                      />
                     </b-col>
                      <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                        >
                          <Vinput
                            inputType="date"
                            :modelValue="addBillData.startDate"
                            @update:modelValue="
                              (newValue) => (addBillData.startDate = newValue)
                            "
                            :rules="{ required: true }"
                            id="text-startDate"
                            name="text-startDate"
                            label="Start Bill on"
                            class="mb-1 mr-sm-2"
                            description="text-startDate-feedback"
                            validatorName="Start Bill on"
                          />
                      </b-col>
                       <b-col class="mt-2">
                      <b-button type="submit" variant="primary">Submit</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </b-modal>
        </div>
      </div>
    </div>
  </template>
  <script>
    import LTable from 'src/components/Table.vue'
    import Card from 'src/components/Cards/Card.vue'
    import Vinput from 'src/components/Inputs/Vinput.vue'
    import Vselect from 'src/components/Inputs/Vselect.vue'
    import VinputNumber from 'src/components/Inputs/VinputNumber.vue'
    import { setLanguage, translate } from 'src/i18n.js';
    export default {
      components: {
        LTable,
        Card,
        Vinput,
        Vselect,
        VinputNumber
      },
      data () {
        return {
          file: null,
          loading: false, // New loading state
          modulePermission: {
            view: 1,
            create: 0,
            update: 0,
            delete: 0
          },
          totalRows: 0,
          currentPage: 1,
          perPage: 7,
          pageOptions: [
            {value: 7, text: 7},
            {value: 10, text: 10},
            {value: 25, text: 25},
            {value: 50, text: 50},
            {value: 100, text: 100}
          ],
          ekubTypeOptions: [
            {value: "Group", text: translate('associationOption')},
            {value: "Individual", text: translate('individual')}
          ],
          cycleOptions: [
          {text: 1, value: 1},
          {text: 2, value: 2},
          {text: 3, value: 3},
          {text: 4, value: 4},
          {text: 5, value: 5},
          {text: 6, value: 6},
          {text: 7, value: 7},
        ],
        cycleOptions2: [
          {text: "Daily", value: 1},
          {text: "Weakly", value: 7},
          {text: "Monthly", value: 30},
          {text: "Yearly", value: 365}
        ],
          items: [],
          filter: "",
          addData: {
            ekubName:"",
            ekubType:"",
            description:"",
            ekubAmount: null,
            ekubId: "",
            cycleDuration: "",
            numberOfEkuber: null,
            cycle: null,
            cycletwo:null,
            startDate:"",
            endDate:"",
            user: {
              id: sessionStorage.getItem("ID")
            },
            userId: sessionStorage.getItem("ID"),
            registeredBy: parseInt(sessionStorage.getItem("userID"))
          },
          addBillData:{
            electricPrice: 0.0,
            waterPrice: 0.0,
            startDate: null,
          },
          billAmountOptions: [
            {text: "----- Please select bill options ----", value:null },
            {text: "No bills", value: "none"},
            {text: "Distribute bill with house size", value: "BySQM"},
            {text: "Distribute with equal amount", value: "EqualForAllHouse"},
            {text: "Define bill for each house", value: "ByAmountForEachHouse"},
            {text: "Define bill reading for each house", value: "ByReading"}
          ],
          selectedEkub: {
          },
          spinner: true
        }
      },
      computed: {
        filterTable() {
          var searchItems = this.items;
          var searchString = this.filter;
          if (searchString === "") {
            return searchItems;
          }
          searchString = searchString.trim().toLowerCase();
  
          searchItems = searchItems.filter(function (item) {
            if (item.buildingName.toLowerCase().indexOf(searchString) !== -1 || item.location.toLowerCase().indexOf(searchString) !== -1 || item.description.toLowerCase().indexOf(searchString) !== -1 ) {
              return item;
            }
          });
          return searchItems;
        },
      },
       mounted() {
        this.getModules();
        this.getEkubsByOwnerID();
        this.$on("AfterComplete", () => {
          this.getEkubsByOwnerID();
        });
      },
      methods: {
        translate,
    changeLanguage(lang) {
      setLanguage(lang);
      this.$forceUpdate();
    },
         // Trigger file input (when Add Bulk Data button is clicked)
  triggerFileInput() {
      this.$bvModal.show('modal-top-add-bulk');
    },

    // Handle file selection
    onFileSelected(file) {
      if (!file) {
        this.file = null;
        alert('No file selected.');
        return;
      }
      this.file = file;
      console.log('File selected:', file.name); // Debugging
    },

    // Confirm and submit file
    confirmAndSubmitFile() {
      this.$bvModal
        .msgBoxConfirm(translate('areYouSureYouWantToSubmitThisForm'), {
          title: translate('confirm'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          cancelVariant: 'danger',
          okTitle:  translate('yes'),
          cancelTitle: translate('nono'),
          bodyClass: 'm-2',
          hideHeaderClose: false,
          centered: false,
        })
        .then((confirmed) => {
          if (confirmed) {
            this.submitFile();
          }
        })
        .catch((err) => {
          console.error('Modal closed without confirmation:', err);
        });
    },

    // Submit the file (parse and send to API)
  submitFile() {
    if (!this.file) {
      alert('Please select a file before submitting.');
      return;
    }
    this.loading = true; // Set loading to true
    const fileExtension = this.file.name.split('.').pop().toLowerCase();

    if (fileExtension === 'csv') {
      this.parseCSV(this.file);
    } else if (fileExtension === 'xls' || fileExtension === 'xlsx') {
      this.parseExcel(this.file);
    } else {
      alert('Please upload a CSV or Excel file.');
      this.loading = false; // Set loading to true
    }
  },

   // Parse CSV file without external library
  parseCSV(file) {
    const reader = new FileReader();
    reader.onload = (event) => {
      const fileContent = event.target.result;
      // console.log('CSV file content:', fileContent);  // Debugging

      // Manually parse the CSV data
      const parsedData = this.csvToJson(fileContent);

      // Map the CSV data to the expected JSON format
      const jsonData = this.mapDataToJson(parsedData);
      this.sendDataToAPI(jsonData);
    };
    reader.readAsText(file);
  },
  // Convert CSV to JSON format
  csvToJson(csv) {
    const lines = csv.split('\n');
    const result = [];
    const headers = lines[0].split(','); // Assuming the first line is the header

    // Iterate over the remaining lines (data rows)
    for (let i = 1; i < lines.length; i++) {
      const currentLine = lines[i].split(',');
      if (currentLine.length === headers.length) { // Ensure the row matches the header length
        const obj = {};
        for (let j = 0; j < headers.length; j++) {
          obj[headers[j].trim()] = currentLine[j].trim();
        }
        result.push(obj);
      }
    }

    return result;
  },

    // Map data to JSON
    mapDataToJson(data) {
      return data.map((item) => ({
        user:{
          id: sessionStorage.getItem("ID")
        },
        userId: sessionStorage.getItem("ID"),
        ekubName: item['ekubName'],
        ekubAmount: item['ekubAmount'],
        cycle: item['cycle'],
        numberOfEkuber: item['numberOfEkuber'],
        ekubType: item['ekubType'],
        ekubStartDate: item['ekubStartDate'],
        ekubEndDate: item['ekubEndDate'],
        description: item['description'],
        registeredBy: parseInt(sessionStorage.getItem("userID")),
      }));
    },

    // Send data to API
    sendDataToAPI(data) {
      this.$store
        .dispatch('AddBulkAssociationForUser', data)
        .then((response) => {
          this.$notifications.notify({
            message: `<span>Data uploaded successfully:</span>`,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success',
          });
          this.$bvModal.hide('modal-top-add-bulk');
          this.clearData();
          setTimeout(() => {
              location.reload();
            }, 2000); // Adjust delay as needed
        })
        .catch((error) => {
          console.error('API Error:', error); // Debugging
          this.$notifications.notify({
            message: (error.response && error.response.data) || 'Upload failed.',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger',
          });
          this.clearData();
          setTimeout(() => {
              location.reload();
            }, 2000); // Adjust delay as needed
        });
    },
  // Download sample file
  downloadSampleFile() {
    const sampleData = [
      ['Number', 'ekubName', 'ekubAmount', 'cycle', 'numberOfEkuber', 'ekubType', 'ekubStartDate', 'ekubEndDate', 'description'],
      [1,'ጢሞስ ማር እና የማር ውጤቶች ንግድ አ.ማ', 400, 30, 300, 'Group', '2024-11-25', '2025-12-25', 'Sample description'],
      [2,'ሲልቫነስ የምግብ ዘይት ፋብሪካ አ.ማ', 400, 30, 150, 'Group', '2024-11-25', '2025-12-25', 'Sample description'],
    ];

     // Add BOM for UTF-8 encoding
  let csvContent = '\ufeff'; // BOM
  sampleData.forEach((rowArray) => {
    const row = rowArray.join(',');
    csvContent += row + '\r\n';
  });
  const encodedUri = encodeURI('data:text/csv;charset=utf-8,' + csvContent);
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', 'sample-file.csv');
  link.click();
  },
        getModules(){
          this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
            .then(response=>{
                //this.items = response.data;
                var modulesList = response.data.modules;
                var EkubModule = modulesList.filter(x=>x.name === "Association");
                if(EkubModule !== null){
                  this.modulePermission.view = EkubModule[0].listData;
                  this.modulePermission.create = EkubModule[0].createData;
                  this.modulePermission.update = EkubModule[0].updateData;
                  this.modulePermission.delete = EkubModule[0].deleteData;
                }
            })
            .catch(error=>{
                console.log(error);
            })
        },
        getEkubsByOwnerID(){
            this.$store.dispatch('getEkubsByOwnerID', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage})
            .then(response=>{
                this.items = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
        },
        changePage(event, page){
          this.spinner = true;
          this.$store.dispatch('getEkubsByOwnerID', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: page, line: this.perPage})
            .then(response=>{
                this.items = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
        },
        changePerPage(event){
          this.spinner = true;
          this.$store.dispatch('getEkubsByOwnerID', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage})
            .then(response=>{
                this.items = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
        },
        AddBillsForBuilding(ID){
          this.selectedEkub.ekubId = ID;
          this.$bvModal.show('modal-top-AddBillsForBuilding');

        },
        submitChangeBillForm(){
          this.$bvModal.msgBoxConfirm('Are you sure you want to change bills ?', {
                title: 'Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                cancelVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                bodyClass: 'm-2',
                hideHeaderClose: false,
                centered: false
            })
          .then(value => {
              if(value === true){
                this.$store.dispatch('AddBillsForBuilding', {
                  building:{
                    buildingId: this.selectedEkub.buildingId
                  },
                  user:{
                    id:sessionStorage.getItem("userID")
                  }, 
                  electricBill: parseFloat(this.addBillData.electricPrice),
                  waterBill: parseFloat(this.addBillData.waterPrice),
                  startDate: this.addBillData.startDate })
                .then(response=>{
                    this.$notifications.notify(
                      {
                        message: `<span>Bills Successfully Updated.</span>`,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'success'
                      })
                      this.$bvModal.hide('modal-top-AddBillsForBuilding');
                      this.$bvModal.hide('modal-top-changePrice');
                      this.clearData();
                })
                .catch(error=>{
                  this.$notifications.notify(
                      {
                        message: error.response.data,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'danger'
                      })
                    console.log(error);
                })
              }
          })
          .catch(error=>{
              console.log(error)
          })
        },
        AddEkub(){
          this.$bvModal.show('modal-center-add');
        },
        submitAddForm(){
              this.$bvModal.msgBoxConfirm(translate('areYouSureYouWantToSubmitThisForm'), {
                   title: translate('confirm'),
                   size: 'sm',
                   buttonSize: 'sm',
                   okVariant: 'success',
                   cancelVariant: 'danger',
                   okTitle:  translate('yes'),
                   cancelTitle: translate('nono'),
                   bodyClass: 'm-2',
                   hideHeaderClose: false,
                   centered: false
               })
               .then(value => {
                if(value === true){
                  var cycle = this.addData.cycle * this.addData.cycletwo;
                    this.$store.dispatch('AddAssociationForUser', {
                      ekubName: this.addData.ekubName,
                      ekubType: this.addData.ekubType,
                      ekubAmount: this.addData.ekubAmount,  
                      numberOfEkuber: this.addData.numberOfEkuber,
                      user:{
                        id: sessionStorage.getItem("ID")
                      },
                      cycle:cycle,
                      userId: sessionStorage.getItem("ID"),
                      ekubStartDate: this.addData.startDate,
                      ekubEndDate: this.addData.endDate,
                      description: this.addData.description,
                      registeredBy: parseInt(sessionStorage.getItem("userID")),
                      superUserId: parseInt(sessionStorage.getItem("superID"))
                    })
                      .then(response=>{
                        // console.log("data",this.addData);
                          this.$notifications.notify(
                            {
                              message: `<span>Association successfully created.</span>`,
                              horizontalAlign: 'center',
                              verticalAlign: 'top',
                              type: 'success'
                            })
                            this.$bvModal.hide('modal-center-add');
                            this.clearData();
                      })
                      .catch(error=>{
                         this.$notifications.notify(
                            {
                              message: error.response.data,
                              horizontalAlign: 'center',
                              verticalAlign: 'top',
                              type: 'danger'
                            })
                          console.log(error);
                      })
                   }
               })
               .catch(error=>{
                    console.log(error)
               })
        },
        EditEkub(ID){
          var Ekub= this.items.filter(item=> item.ekubId == ID)[0];
          this.selectedEkub.ekubName = Ekub.ekubName;
          this.selectedEkub.ekubType = Ekub.ekubType;
          this.selectedEkub.description = Ekub.description;
          this.selectedEkub.id = Ekub.ekubId;
          this.selectedEkub.ekubAmount = Ekub.ekubAmount;
          this.selectedEkub.cycleDuration = Ekub.cycleDuration;
          this.selectedEkub.description = Ekub.description;
          this.selectedEkub.startDate = Ekub.ekubStartDate;
          this.selectedEkub.endDate = Ekub.ekubEndDate;
          this.selectedEkub.numberOfEkuber = Ekub.numberOfEkuber;
          if(Ekub.cycle<7){
          this.selectedEkub.cycle = Ekub.cycle;
          this.selectedEkub.cycletwo = 1;
          }else if (Ekub.cycle<30){
          this.selectedEkub.cycle = Ekub.cycle/7;
          this.selectedEkub.cycletwo = 7;
          }else if (Ekub.cycle<365){
          this.selectedEkub.cycle = Ekub.cycle/30;
          this.selectedEkub.cycletwo = 30;
          }else{
          this.selectedEkub.cycle = Ekub.cycle/365;
          this.selectedEkub.cycletwo = 365;
          }
          
          this.$bvModal.show('modal-top-EditEkub');
        },
        submitEditForm(){
          this.$bvModal.msgBoxConfirm(translate('areYouSureYouWantToSubmitThisForm'), {
              title: translate('confirm'),
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle:  translate('yes'),
              cancelTitle: translate('nono'),
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
          .then(value => {
            if(value === true){
                  var cycle = this.selectedEkub.cycle * this.selectedEkub.cycletwo;
                    this.$store.dispatch('EditEkub', {
                      id: this.selectedEkub.id,
                      ekubName: this.selectedEkub.ekubName,
                      ekubType: this.selectedEkub.ekubType,
                      ekubAmount: this.selectedEkub.ekubAmount,  
                      numberOfEkuber: this.selectedEkub.numberOfEkuber,
                      cycle:cycle,
                      ekubStartDate: this.selectedEkub.startDate,
                      ekubEndDate: this.selectedEkub.endDate,
                      description: this.selectedEkub.description
                    })
                .then(response=>{
                    this.$notifications.notify(
                      {
                        message: `<span>Association Successfully Updated.</span>`,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'success'
                      })
                      this.$bvModal.hide('modal-top-EditEkub');
                      this.clearData();
                })
                .catch(error=>{
                  console.log(error);
                  this.$notifications.notify(
                      {
                        message: error.response.data,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'danger'
                      })
                    console.log(error);
                })
              }
          })
          .catch(error=>{
              console.log(error)
          })
        },
        clearData(){
          this.addData.cycle = "";
          this.addData.cycleDuration = "";
          this.addData.cycletwo = "";
          this.addData.ekubName = "";
          this.addData.ekubType = "";
          this.addData.startDate = "";
          this.addData.endDate = "";
          this.addData.registeredBy = "";
          this.addData.numberOfEkuber = "";
          this.addData.ekubId = "";
          this.addData.registeredBy = "";
          this.addData.ekubAmount = "";
          this.selectedEkub = {};
          this.$emit('AfterComplete');
        }
      }
    }
  </script>
  <style scoped>
  .b-table-sticky-column:last-child {
    right: 0;
  }
  .text-warning {
      color: rgba(240, 206, 13, 0.937) !important;
  }
  .btn-icon{
    font-size: 27px !important;
    padding: 3px 5px 3px 5px;
    width: 40px;
    color:  rgb(37, 91, 48);
    border: 2px solid rgb(37, 91, 48);
  }
  .btn-icon:hover,
  .btn-icon:focus {
    cursor: pointer;
    background-color: rgb(37, 91, 48) !important;
    color: rgba(240, 206, 13, 0.937) !important;
    border-radius: 4px;
    transition: .4s;
  }
  .table-container {
  display: flex;
  flex-direction: column;
  max-height: calc(80vh - 0px); /* Adjust depending on other UI elements */
  overflow-y: auto;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .custom-dropdown {
    max-width: 100%; /* Ensure dropdown expands on mobile */
  }

  .pagination-container {
    margin-top: 20px;
  }

  .table-container {
    max-height: 50vh; /* Lower height for better mobile usability */
  }

  .b-button-toolbar {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .b-button {
    padding: 8px;
    margin: 5px;
  }
  .table-container {
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: auto;
}
}
.sticky-header {
  position: sticky;
  top: 0;
  background-color: #fff; /* Ensure header has a background */
  z-index: 1; /* Ensure it stays on top of the table body */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Optional: Add shadow for better visibility */
}
  </style>
  